import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-148e2b2e")

_pushScopeId("data-v-148e2b2e")
const _hoisted_1 = { class: "flex flex-row items-center justify-between w-full p-4" }
const _hoisted_2 = { class: "flex items-center w-full" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('pickupDashboard.manageArea.search')
      }, {
        default: _withId(() => [
          _createVNode(_component_Search, {
            id: "modal-geo-address-search",
            placeholder: 
            _ctx.$t('pickupDashboard.manageArea.searchSubDistrictPlaceholder')
          ,
            class: "mt-2 w-full lg:w-80",
            timeout: 300,
            value: _ctx.modelValue.q,
            onClear: () => _ctx.onSearch(''),
            onInput: _ctx.onSearch,
            onEnter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch($event.target.value)))
          }, null, 8, ["placeholder", "value", "onClear", "onInput"])
        ]),
        _: 1
      }, 8, ["label"])
    ])
  ]))
})